import type React from "react";
import type { ReactNode } from "react";

interface Props {
	children: ReactNode;
	size?: "md" | "lg";
}

const sizingClasses = (size: "md" | "lg"): string => {
	switch (size) {
		case "md":
			return "p-8 md:pt-12 md:px-8";
		case "lg":
			return "wide p-8 md:pt-12 md:px-8";
	}
};

export const ContentContainer: React.FC<Props> = ({ children, size }) => {
	return (
		<section className={`main-container ${sizingClasses(size ?? "md")}`}>
			<div className="flex flex-col justify-center items-center mb-6">
				<div className="main-logo" />
			</div>
			{children}
		</section>
	);
};
